<template>
  <v-card class="pa-4 d-flex flex-column align-end mt-5 ml-2 minHeight" elevation="1">
    <!-- Card menor no canto superior esquerdo -->
    <v-avatar
      class="pa-3"
      :color="corAvatar"
      size="35"
      style="position: absolute; top: -12px; left: 10px"
    >
      <v-icon size="25">{{ icon }}</v-icon>
    </v-avatar>

    <!-- Número principal -->
    <div class="text-h4 font-weight-bold">
      {{ formattedValue }}
    </div>

    <!-- Linha divisória -->
    <v-divider class="my-2"></v-divider>

    <!-- Texto explicativo -->
    <div class="text-caption text-grey-darken-1">
      {{ text }}
      <v-btn
        v-if="action"
        outlined
        text
        class="ml-2"
        @click="$emit('abrir-modal', item, index, academiaId, data)"
      >
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    value: [String, Number], // Pode ser string ou número
    icon: String,
    action: { type: Boolean, default: false },
    item: { type: String, default: null },
    data: { type: Array, default: null },
    index: { type: Number, default: null },
    academiaId: { type: Number, default: null },
    text: String,
    currency: { type: Boolean, default: false }, // Se verdadeiro, formatar como moeda, default false,
    corAvatar: String,
  },
  computed: {
    formattedValue() {
      if (typeof this.value === 'number') {
        return Number.isInteger(this.value)
          ? this.currency
            ? this.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            : this.value.toLocaleString('pt-BR') // Inteiro → 1.000
          : this.currency
          ? this.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          : this.value.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }); // Decimal → 1.000,00
      }
      return this.value; // Se não for número, retorna o valor original
    },
  },
};
</script>
<style scoped>
.minHeight {
  min-height: 130px;
}
</style>
